import { ENDPOINTS, get, put } from '~/api'
import { coolingDownThresholdInMinutes } from '~/common/constants'
import { ConfigManager } from '~/managers/ConfigManager'
import { FlipperKey } from '~/store/flippers/types'
import { ActionTypes, Dispatch, GetState } from '~/store/types'
import { ACK_TYPES, FLIPPER_RESPONSE_MAP } from './const'
import { StateFlippers } from './reducer'
import { selectTwoFaSetupTime } from './selectors'
import { ROUTE_ACTIONS } from './types'
import { PATHS } from '~/routes/paths'

const getIsWithin12Hours = (utcTimeStamp: number) => {
  const currentTime = new Date().getTime()
  const twelveHoursInMillis = coolingDownThresholdInMinutes * 60 * 1000
  const twelveHoursFromTimestamp = utcTimeStamp + twelveHoursInMillis
  const remainingTimeInMillis = twelveHoursFromTimestamp - currentTime

  return remainingTimeInMillis > 0
}

export const fetchTwoFaStatus =
  () => async (dispatch: Dispatch<ActionTypes>, getState: GetState) => {
    const isWithin12Hours = getIsWithin12Hours(selectTwoFaSetupTime(getState()))
    const twoFaResp = await get(ENDPOINTS.API_SSO_TWO_FA)

    return dispatch({
      type: ROUTE_ACTIONS.SET_USER_PROFILE,
      user: {
        ...getState().route.user,
        twoFa: {
          ...getState().route.user.twoFa,
          isOnCoolingDownPeriod: isWithin12Hours,
          twoFaList: twoFaResp[0]?.userCredentialMetadatas || [],
        },
      },
    })
  }

export const acknowledgeDashboardRevampTourDone = () => (dispatch: Dispatch<ActionTypes>) => {
  const requestBody = {
    ack_type: ACK_TYPES.DASHBOARD_REVAMP,
    is_acknowledged: true,
    is_dont_show_again: true,
  }

  dispatch({ type: ROUTE_ACTIONS.SET_ACKNOWLEDGE_DASHBOARD_REVAMP })
  // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/no-unsafe-argument
  put(ENDPOINTS.API_ACKNOWLEDGE_POP_UP_MESSAGE, requestBody)
}

export const acknowledgeStablecoinTransferDisclaimer = () => (dispatch: Dispatch<ActionTypes>) => {
  if (ConfigManager.isBizSite()) return

  const requestBody = {
    ack_type: ACK_TYPES.STABLECOIN_TRANSFER_DISCLAIMER,
    is_acknowledged: true,
    is_dont_show_again: true,
  }

  dispatch({
    type: ROUTE_ACTIONS.SET_ACKNOWLEDGE_TRANSFER_DISCLAIMER,
    isStablecoinTransferDisclaimerAcknowledged: true,
  })
  // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/no-unsafe-argument
  put(ENDPOINTS.API_ACKNOWLEDGE_POP_UP_MESSAGE, requestBody)
}

export const acknowledgeDirectMintEducationalBanner = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({ type: ROUTE_ACTIONS.SET_ACKNOWLEDGE_DIRECT_MINT_EDUCATIONAL_BANNER })
  // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/no-unsafe-argument
  put(ENDPOINTS.API_ACKNOWLEDGE_POP_UP_MESSAGE, {
    ack_type: ACK_TYPES.DIRECT_MINT_EDUCATIONAL_BANNER,
    is_acknowledged: true,
    is_dont_show_again: true,
  })
}

export const acknowledgeAntiScam = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({ type: ROUTE_ACTIONS.SET_ACKNOWLEDGE_ANTI_SCAM })
  // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/no-unsafe-argument
  put(ENDPOINTS.API_ACKNOWLEDGE_POP_UP_MESSAGE, {
    ack_type: ACK_TYPES.ANTI_SCAM,
    is_acknowledged: true,
    is_dont_show_again: true,
  })
}

export const redirect = (to: PATHS) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: ROUTE_ACTIONS.SET_REDIRECT,
    to,
  })
}

// TODO(benedictkhoo): remove after unification project is completed
export const fecthUserIdentifier = () => (dispatch: Dispatch<ActionTypes>) => {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  get(ENDPOINTS.API_SSO_PROFILE).then((res) => {
    if (!res) {
      return
    }

    if (res.kc_id) {
      dispatch({
        type: ROUTE_ACTIONS.SET_USER_KC_ID,
        kcId: res.kc_id,
      })
    }

    if (ConfigManager.isBizSite() && res.biz_id) {
      dispatch({
        type: ROUTE_ACTIONS.SET_USER_BIZ_ID,
        bizId: res.biz_id,
      })
    }
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setFlippers =
  (keys: FlipperKey[], flipperResponse: any) => (dispatch: Dispatch<ActionTypes>) => {
    const flippers = new Map<keyof StateFlippers, boolean>()

    if (keys && flipperResponse) {
      keys.forEach((key) => {
        const prop = FLIPPER_RESPONSE_MAP[key]
        const enabled = flipperResponse[key]

        if (prop && enabled !== undefined) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          flippers.set(prop, enabled)
        }
      })

      if (flippers.size > 0) {
        dispatch({
          type: ROUTE_ACTIONS.SET_FLIPPERS,
          flippers,
        })
      }
    }
  }
